"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import classNames from "classnames";
import { computed, observable, action, runInAction } from "mobx";
import { observer } from "mobx-react";
import React, { forwardRef, Children } from "react";
import { Transition } from "react-transition-group";
import * as utils from "../../../utils";
import { AnimationDuration } from "../../../styles/Animations";
import { Spinner } from "../Spinner/Spinner";
import forceReflow from "../../../utils/forceReflow";
import { ChevronDown, ArrowRight, Tick } from "../../icons";
import * as styles from "./Button-css";
export var ButtonType = /* @__PURE__ */ ((ButtonType2) => {
  ButtonType2["Primary"] = "primary";
  ButtonType2["Secondary"] = "secondary";
  ButtonType2["Tertiary"] = "tertiary";
  return ButtonType2;
})(ButtonType || {});
export var ButtonState = /* @__PURE__ */ ((ButtonState2) => {
  ButtonState2["Idle"] = "idle";
  ButtonState2["Waiting"] = "waiting";
  ButtonState2["Success"] = "success";
  return ButtonState2;
})(ButtonState || {});
export var ButtonSize = /* @__PURE__ */ ((ButtonSize2) => {
  ButtonSize2["XSmall"] = "x-small";
  ButtonSize2["Small"] = "small";
  ButtonSize2["Medium"] = "medium";
  ButtonSize2["Large"] = "large";
  return ButtonSize2;
})(ButtonSize || {});
export var ButtonDecorator = /* @__PURE__ */ ((ButtonDecorator2) => {
  ButtonDecorator2["Dropdown"] = "dropdown";
  ButtonDecorator2["Arrow"] = "arrow";
  return ButtonDecorator2;
})(ButtonDecorator || {});
export var ButtonTheme = /* @__PURE__ */ ((ButtonTheme2) => {
  ButtonTheme2["Light"] = "light";
  ButtonTheme2["Dark"] = "dark";
  return ButtonTheme2;
})(ButtonTheme || {});
let ButtonComponent = class extends React.Component {
  constructor(props) {
    super(props);
    this.renderChild = (child) => {
      if (child === null)
        return;
      if (typeof child === "string") {
        return /* @__PURE__ */ React.createElement("span", { className: classNames(styles.text, "button__text") }, child);
      }
      return child;
    };
    this.id = props.id ? props.id : `button-${utils.randomString()}`;
    this._internalButtonState = "idle" /* Idle */;
  }
  get buttonState() {
    return this.isControlled ? this.props.buttonState : this._internalButtonState;
  }
  get isControlled() {
    return !!this.props.buttonState;
  }
  render() {
    const _a = this.props, {
      buttonState,
      onClick,
      successMessage,
      as,
      className,
      type,
      size,
      width,
      isRound,
      disabled,
      innerRef,
      children,
      href,
      decorator,
      openInSameTab,
      isIconOnly,
      theme,
      isDestructive
    } = _a, rest = __objRest(_a, [
      "buttonState",
      "onClick",
      "successMessage",
      "as",
      "className",
      "type",
      "size",
      "width",
      "isRound",
      "disabled",
      "innerRef",
      "children",
      "href",
      "decorator",
      "openInSameTab",
      "isIconOnly",
      "theme",
      "isDestructive"
    ]);
    const ButtonElement = !!href ? "a" : as;
    const isDisabledAndIdle = disabled && this.buttonState === "idle" /* Idle */;
    const isLink = as === "a" || !!href;
    const isNonSelfReferencingLink = isLink && !!href && !/^\/[^/]/.test(href());
    return /* @__PURE__ */ React.createElement(
      ButtonElement,
      __spreadValues({
        className: classNames([
          styles.button({ size, type, state: this.buttonState, width, isRound, isDestructive, isIconOnly }),
          "button",
          className,
          `button--${type}`,
          `button--${size}`,
          `button--${width}-width`,
          `button--id-${this.id}`,
          `button--${theme}`,
          {
            "button--icon-only": isIconOnly,
            "button--destructive": isDestructive,
            "button--is-round": isRound,
            "button--is-disabled": disabled,
            [`button--is-${isLink ? "idle" /* Idle */ : this.buttonState}`]: !isDisabledAndIdle
          }
        ]),
        id: this.id,
        onClick: this.handleClick,
        onMouseEnter: this.props.onMouseEnter,
        onMouseLeave: this.props.onMouseLeave,
        ref: innerRef,
        disabled,
        href: !!href ? href() : void 0,
        target: isNonSelfReferencingLink && !openInSameTab ? "_blank" : void 0,
        rel: isNonSelfReferencingLink && !openInSameTab ? "noopener noreferrer" : void 0
      }, rest),
      /* @__PURE__ */ React.createElement(Transition, { in: this.showContent, timeout: AnimationDuration.Medium, onEnter: forceReflow }, (status) => /* @__PURE__ */ React.createElement("div", { className: classNames(styles.content({ status }), "button__content", `button__content--${status}`) }, Children.map(children, this.renderChild), decorator === "dropdown" /* Dropdown */ && /* @__PURE__ */ React.createElement(ChevronDown, null), decorator === "arrow" /* Arrow */ && /* @__PURE__ */ React.createElement(ArrowRight, { className: classNames(styles.arrowIcon, "button__arrow-icon") }))),
      /* @__PURE__ */ React.createElement(
        Transition,
        {
          mountOnEnter: true,
          unmountOnExit: true,
          in: this.buttonState === "waiting" /* Waiting */,
          timeout: AnimationDuration.Medium,
          onEnter: forceReflow
        },
        (status) => /* @__PURE__ */ React.createElement(
          Spinner,
          {
            size: "s",
            className: classNames(styles.status({ status }), "button__spinner", `button__spinner--${status}`)
          }
        )
      ),
      /* @__PURE__ */ React.createElement(
        Transition,
        {
          mountOnEnter: true,
          unmountOnExit: true,
          in: this.buttonState === "success" /* Success */,
          timeout: AnimationDuration.Medium,
          onEnter: forceReflow
        },
        (status) => /* @__PURE__ */ React.createElement("div", { className: classNames(styles.status({ status }), "button__success", `button__success--${status}`) }, !!successMessage && /* @__PURE__ */ React.createElement("div", { className: classNames(styles.successText, "button__success-text"), "aria-live": "polite" }, successMessage), /* @__PURE__ */ React.createElement(Tick, { className: classNames(styles.successIcon, "button__success-icon") }))
      )
    );
  }
  handleClick(event) {
    return __async(this, null, function* () {
      if (!this.props.onClick) {
        return;
      }
      if (!this.isControlled && this._internalButtonState !== "idle" /* Idle */) {
        return;
      }
      const result = this.props.onClick(event);
      const shouldTransitionState = !this.isControlled && result instanceof Promise;
      if (shouldTransitionState) {
        this._internalButtonState = "waiting" /* Waiting */;
        try {
          yield Promise.all([result, utils.delay(500)]);
          runInAction(() => {
            this._internalButtonState = "success" /* Success */;
            setTimeout(() => {
              if (this._internalButtonState === "success" /* Success */) {
                this._internalButtonState = "idle" /* Idle */;
              }
            }, 3500);
          });
        } catch (error) {
          this._internalButtonState = "idle" /* Idle */;
        }
      }
    });
  }
  get showContent() {
    return this.buttonState !== "waiting" /* Waiting */ && this.buttonState !== "success" /* Success */;
  }
};
ButtonComponent.defaultProps = {
  type: "primary" /* Primary */,
  size: "medium" /* Medium */,
  width: "normal",
  as: "button",
  theme: "light" /* Light */
};
__decorateClass([
  observable.ref
], ButtonComponent.prototype, "_internalButtonState", 2);
__decorateClass([
  computed
], ButtonComponent.prototype, "buttonState", 1);
__decorateClass([
  computed
], ButtonComponent.prototype, "isControlled", 1);
__decorateClass([
  action.bound
], ButtonComponent.prototype, "handleClick", 1);
__decorateClass([
  computed
], ButtonComponent.prototype, "showContent", 1);
ButtonComponent = __decorateClass([
  observer
], ButtonComponent);
const Button = forwardRef(
  function button(props, ref) {
    return /* @__PURE__ */ React.createElement(ButtonComponent, __spreadValues({ innerRef: ref }, props));
  }
);
export default Button;
